import { render, staticRenderFns } from "./distributionSolider.vue?vue&type=template&id=2c01050e&scoped=true&"
import script from "./distributionSolider.vue?vue&type=script&lang=js&"
export * from "./distributionSolider.vue?vue&type=script&lang=js&"
import style0 from "./distributionSolider.vue?vue&type=style&index=0&id=2c01050e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c01050e",
  null
  
)

export default component.exports